import { Box, Button, FormHelperText, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Controller, useFormContext } from "react-hook-form";
import { DynDadosCadastraisProps } from "..";
import { useState } from "react";
import DialogAddEditFazenda from "./DialogAddEditFazenda";

export default function DadosFazendas({ spec, extras }: DynDadosCadastraisProps) {
    const { control, watch, setValue } = useFormContext();

    const [openFazendaModal, setOpenFazendaModal] = useState<TOpenModalDadosFazenda>({ open: false });

    const fazendas = watch(`${spec.name}.fazendas`) || [];
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 };

    return (
        <>
            <Grid container size={{ xs: 12 }} spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <Typography fontWeight={'bold'} variant="h6">Dados das propriedades</Typography>
                </Grid>
                {
                    fazendas.length > 0 &&
                    <>
                        <Grid size={{ xs: 12 }}>
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={paddingStyle}>
                                                <b>Nome</b>
                                            </TableCell>
                                            <TableCell></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fazendas.map((item: IDadosFazenda, index: number) => (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <Controller
                                                    name={`${spec.name}.fazendas[${index}]`}
                                                    control={control}
                                                    rules={{ required: "Campo obrigatório" }}
                                                    render={({ field, fieldState: { error, invalid } }) => (
                                                        <TableCell sx={{ ...paddingStyle, color: invalid ? 'red' : 'inherit' }}>
                                                            {item.nome}* {invalid && "Campo obrigatório"}
                                                        </TableCell>
                                                    )}
                                                />
                                                <TableCell sx={paddingStyle}>
                                                    <Box
                                                        display="flex"
                                                        alignItems="center"
                                                        justifyContent="flex-end"
                                                    >
                                                        <IconButton
                                                            aria-label="edit"
                                                            onClick={() => {
                                                                setOpenFazendaModal({ open: true, index });
                                                            }}
                                                        >
                                                            <EditIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            aria-label="delete"
                                                            onClick={() => {
                                                                const novasFazendas = fazendas.filter((_: any, i: number) => i !== index);
                                                                setValue(`${spec.name}.fazendas`, novasFazendas);
                                                            }}
                                                        >
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </>
                }
                <Grid size={{ xs: 12 }}>
                    <Controller
                        name={`${spec.name}.fazendas`}
                        control={control}
                        rules={{ required: "Campo obrigatório" }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <>
                                <Button
                                    variant="outlined"
                                    color={error ? 'error' : 'primary'}
                                    startIcon={<AddIcon />}
                                    onClick={() => setOpenFazendaModal({ open: true })}
                                >
                                    Adicionar Fazenda
                                </Button>
                                <FormHelperText error>{invalid && error ? error.message : ""}</FormHelperText>
                            </>
                        )}
                    />
                </Grid>
            </Grid>
            {
                openFazendaModal.open &&
                <DialogAddEditFazenda
                    open={openFazendaModal.open}
                    index={openFazendaModal.index}
                    onClose={() => setOpenFazendaModal({ open: false })}
                />
            }
        </>
    )
}

export type TOpenModalDadosFazenda = {
    open: boolean;
    index?: number;
}

export interface IDadosFazenda {
    nome: string;
}
